const DownloadIcon = ({ style, color = '#141B34', height = '24px', width = '24px' }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={style} width={width} height={height} color={color} fill="none">
			<path
				d="M21 16.25C21.414 16.25 21.75 16.5858 21.75 17V19.5C21.75 20.7426 20.743 21.75 19.5 21.75H4.5C3.257 21.75 2.25 20.7426 2.25 19.5V17C2.25 16.5858 2.586 16.25 3 16.25C3.414 16.25 3.75 16.5858 3.75 17V19.5C3.75 19.9142 4.086 20.25 4.5 20.25H19.5C19.914 20.25 20.25 19.9142 20.25 19.5V17C20.25 16.5858 20.586 16.25 21 16.25ZM12 2.25C12.414 2.25003 12.75 2.58581 12.75 3V14.1895L15.97 10.9697C16.263 10.6769 16.737 10.6768 17.03 10.9697C17.323 11.2626 17.323 11.7374 17.03 12.0303L12.53 16.5303C12.237 16.8232 11.763 16.8231 11.47 16.5303L6.97 12.0303C6.677 11.7374 6.677 11.2626 6.97 10.9697C7.263 10.6769 7.737 10.6768 8.03 10.9697L11.25 14.1895V3C11.25 2.58579 11.586 2.25 12 2.25Z"
				fill={color}
			/>
		</svg>
	);
};

export default DownloadIcon;
